import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetReporting = (filters) => axios.get(`${apiPaths.reportingBase}/claims-and-settlements`, { params: filters });

const onGetProfitabilityReporting = (filters) =>
  axios.get(`${apiPaths.reportingBase}/profitability`, { params: filters });

const onGetRiskOutliersReporting = () => axios.get(`${apiPaths.reportingBase}/risk-outliers`);

export { onGetReporting, onGetProfitabilityReporting, onGetRiskOutliersReporting };
